import {call, put, takeLatest} from 'redux-saga/effects';
import GameXpHighlightsApi from '../../api/GameXpHighlightsApi';
import gameXpHighlightsActions from '../../actions/fortnite-game/gameXpHighlights.actions';
import getErrorCodeFromResponse from '../../utils/errors/getErrorCodeFromResponse';
import {NO_DATA_ERROR_CODE} from './constants';

function* getGameXpHighlights(action) {
    try {
        delete action.payload.silent;

        const {data} = yield call(GameXpHighlightsApi.getData, action.payload);

        yield put(
            gameXpHighlightsActions.getGameXpHighlightsSuccess({
                data,
                error: data && data.activations.length ? undefined : NO_DATA_ERROR_CODE
            })
        );
    } catch (e) {
        yield put(
            gameXpHighlightsActions.getGameXpHighlightsFailed(getErrorCodeFromResponse(e), e)
        );
    }
}

function* gameXpHighlightsSaga() {
    yield takeLatest(gameXpHighlightsActions.TYPES.GET_GAME_XP_HIGHLIGHTS, getGameXpHighlights);
}

export default gameXpHighlightsSaga;
